<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
/* eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text */
import { ref } from 'vue';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';

defineProps({
  targetPhone: { type: String, default: '' },
  targetTitle: { type: String, default: '' },
  reason: { type: String, default: '' },
  isLoading: { type: Boolean, default: false },
  disableConfirm: { type: Boolean, default: false },
  textareaClass: { type: String, default: '' },
});

const emit = defineEmits(['confirm', 'close', 'update:reason']);

const dialogRef = ref(null);

defineExpose({
  open: () => dialogRef.value?.open(),
  close: () => dialogRef.value?.close(),
});
</script>

<template>
  <Dialog
    ref="dialogRef"
    title="Adicionar à blacklist"
    confirm-button-label="Adicionar"
    cancel-button-label="Cancelar"
    :is-loading="isLoading"
    :disable-confirm-button="disableConfirm"
    @confirm="emit('confirm')"
    @close="emit('close')"
  >
    <div class="space-y-4 text-[13px] text-lais-text">
      <div class="rounded-lais border border-red-100 bg-red-50 px-4 py-3">
        <div class="flex items-start gap-3">
          <span
            class="grid size-9 shrink-0 place-items-center rounded-full bg-white text-red-700 ring-1 ring-red-100"
          >
            <span class="i-lucide-ban size-4" aria-hidden="true" />
          </span>
          <div class="min-w-0">
            <p class="text-[11px] font-bold uppercase text-red-700">
              Bloquear telefone
            </p>
            <p class="mt-1 font-semibold text-lais-text">
              {{ targetPhone }}
            </p>
            <p class="mt-0.5 text-[12px] text-lais-text-muted">
              {{ targetTitle }}
            </p>
          </div>
        </div>
      </div>

      <label class="grid gap-1">
        <span class="text-[11px] font-semibold text-lais-text-muted">
          Motivo
        </span>
        <textarea
          :value="reason"
          :class="textareaClass"
          placeholder="Explique o motivo da inclusão deste telefone na blacklist."
          @input="emit('update:reason', $event.target.value)"
        />
      </label>
    </div>
  </Dialog>
</template>
